import { authClient } from '@/lib/auth-client';
import { http } from '..';
import type { GetSubscriptionResponse } from './types';

const PLANS = {
  free: {
    name: 'free',
    maxProjectsCount: 1,
  },
  starter: {
    name: 'starter',
    maxProjectsCount: 3,
  },
  scaler: {
    name: 'scaler',
    maxProjectsCount: 1000,
  },
  enterprise: {
    name: 'enterprise',
    maxProjectsCount: 1000,
  },
};

export const fetchSubscription = async () => {
  const response = await http.url('/admin/subscription').get().json<GetSubscriptionResponse>();
  const { plan } = response.subscription;

  return {
    activeOrganizationId: response.session.activeOrganizationId,
    plan,
    subscriptionPlan: `${plan.charAt(0).toUpperCase()}${plan.slice(1)}`,
    isFree: plan === PLANS.free.name,
    isStarter: plan === PLANS.starter.name,
    isScaler: plan === PLANS.scaler.name,
    allowedProjectsCount: PLANS[plan]?.maxProjectsCount,
    email: response.user.email,
    name: response.user.name,
  };
};

export const checkout = async (params: { products: string[]; referenceId?: string }) => {
  const { data, error } = await authClient.checkout({
    products: params.products,
    referenceId: params.referenceId,
  });

  if (error) {
    throw new Error(error.message);
  }

  return data;
};
